/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IMensesEvent } from 'app/shared/model/menses-event.model';
import { DayType } from 'app/shared/model/enumerations/day-type.model';
import { Mood } from 'app/shared/model/enumerations/mood.model';
import { CycleStatus } from 'app/shared/model/enumerations/cycle-status.model';

export interface ICycleDay {
  id?: string;
  dayType?: keyof typeof DayType | null;
  mood?: keyof typeof Mood | null;
  moodNotes?: string | null;
  desireScale?: number | null;
  status?: keyof typeof CycleStatus | null;
  comments?: string | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  event?: IMensesEvent | null;
}

export const defaultValue: Readonly<ICycleDay> = {
  active: false,
  draft: false,
};
